import { render, staticRenderFns } from "./Material_masters.vue?vue&type=template&id=d321ec66&"
import script from "./Material_masters.vue?vue&type=script&lang=js&"
export * from "./Material_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports